import React, { ReactNode, useCallback, useState } from 'react';
import { HelpModal } from './HelpModal';

interface IUseHelpLink {
  helpModalComponent: ReactNode;
  onHelpClick(event): void;
}

export const useHelpLink = (articleFromProps: string): IUseHelpLink => {
  const [article, setArticle] = useState(null);

  const openHelpModal = useCallback(
    (event) => {
      setArticle(articleFromProps);
      event.stopPropagation();
    },
    [articleFromProps],
  );

  const closeHelpModal = useCallback(() => setArticle(null), []);

  return {
    helpModalComponent: <HelpModal article={article} onClose={closeHelpModal} />,
    onHelpClick: openHelpModal,
  };
};
